<template>
  <div class="contract-table">
    <div class="contract-table__header">
      <div class="contract-table__controls">
        <i-button
          class="ms-button-text"
          type="text"
          @click="goToContract"
        >
          Перейти к проекту
        </i-button>
        <i-button
          class="ms-button-text"
          type="text"
          @click="toggleExpanded"
          style="margin-left: 16px;"
        >
          {{ allExpanded ? 'Свернуть все' : 'Развернуть все' }}
        </i-button>
      </div>
      <div class="contract-table__customer ms-small-head">
        Заказчик: {{ project.customer_name }}
      </div>
    </div>
    <div class="contract-table__roadmaps">
      <i-table :columns="columns" :data="roadmaps" border />
    </div>
    <div class="contract-table__summary">
      <contract-summary :project="project" />
    </div>
  </div>
</template>

<script>
import ContragentsRow from './contragents-row'
import ContractSummary from './contract-summary'
import { getFormattedCosts, round } from '@/utils'

const columns = [
  {
    type: 'expand',
    width: 50,
    render: (h, params) => {
      return h(ContragentsRow, {
        props: {
          row: params.row
        }
      })
    }
  },
  {
    title: 'Номер',
    key: 'number',
    width: 76
  },
  {
    title: 'Наименование этапа',
    key: 'name'
  },
  {
    title: 'Стоимость по договору, руб',
    key: 'costs',
    width: 161,
    render: (h, params) => {
      return h('span', getFormattedCosts(params.row.costs, true))
    }
  },
  {
    title: 'Информация о подписанных актах',
    key: 'sign_acts',
    width: 160
  },
  {
    title: 'Сумма поступившей оплаты (в т.ч. аванс), руб',
    key: 'payments_value',
    width: 192,
    render: (h, params) => {
      return h('span', getFormattedCosts(params.row.payments_value, true))
    }
  },
  {
    title: 'Процент поступившей оплаты, %',
    key: 'payment_part',
    width: 129,
    render: (h, params) => {
      return h('span', round(params.row.payment_part * 100, 1))
    }
  }
]

export default {
  components: {
    ContractSummary
  },
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      allExpanded: false,
      columns
    }
  },
  computed: {
    roadmaps () {
      return this.project.roadmaps.map(r => ({
        ...r,
        _disableExpand: !r.contragents.length
      }))
    }
  },
  methods: {
    goToContract () {
      const { id } = this.project

      this.$store.commit('SET_COME_FROM', 'contracts-register')

      const route = this.$router.resolve({
        path: `/app/contracts/${id}/overview`
      })

      window.open(route.href, '_blank')
    },
    toggleExpanded () {
      const value = !this.allExpanded

      this.project.roadmaps.forEach(r => {
        if (r.contragents.length) {
          this.$set(r, '_expanded', value)

          r.contragents.forEach(c => {
            this.$set(c, '_expanded', value)
          })
        }
      })

      this.allExpanded = value
    }
  }
}
</script>

<style lang="less">
.contract-table {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .ivu-table-expanded-cell {
    padding: 0;

    table {
      width: 100% !important;
    }

    .ivu-table {
      td:last-child {
        border-right: none
      }

      td {
        // border-bottom: none;
        // border-top-width: 1px;
        // border-top-style: solid;
      }
    }
  }

  &__summary {
    margin-top: 24px;
  }
}

.dark {
  .ivu-table-expanded-cell {
    td {
      background: lighten(@dt-dark-bg, 3%) !important;
    }
  }
}

.light {
  .ivu-table-expanded-cell {
    td {
      background: #fcfcfc !important;
    }
  }
}
</style>
